module.exports = __webpack_public_path__ + "img/KeryxLogo.d2090564.png";